/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddMealInsightFeedbackRequest } from '../models/AddMealInsightFeedbackRequest';
import type { CreateMealInsightRequest } from '../models/CreateMealInsightRequest';
import type { SuccessCreateMealInsightResponse } from '../models/SuccessCreateMealInsightResponse';
import type { SuccessVoid } from '../models/SuccessVoid';
import type { UpdateMealInsightRequest } from '../models/UpdateMealInsightRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MealInsightControllerService {

    /**
     * Creates a meal insight for a given file. The file must be owned by the authenticated user.
     * @param requestBody
     * @returns SuccessCreateMealInsightResponse OK
     * @throws ApiError
     */
    public static createMealInsight(
        requestBody: CreateMealInsightRequest,
    ): CancelablePromise<SuccessCreateMealInsightResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/mealinsight',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Adds feedback to a meal insight.
     * @param mealInsightId
     * @param requestBody
     * @returns SuccessVoid OK
     * @throws ApiError
     */
    public static addMealInsightFeedback(
        mealInsightId: string,
        requestBody: AddMealInsightFeedbackRequest,
    ): CancelablePromise<SuccessVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/mealinsight/insights/{mealInsightId}/feedback',
            path: {
                'mealInsightId': mealInsightId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Updates a meal insight.
     * @param mealInsightId
     * @param requestBody
     * @returns SuccessVoid OK
     * @throws ApiError
     */
    public static updateMealInsight(
        mealInsightId: string,
        requestBody: UpdateMealInsightRequest,
    ): CancelablePromise<SuccessVoid> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/mealinsight/insights/{mealInsightId}',
            path: {
                'mealInsightId': mealInsightId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
